import { render, staticRenderFns } from "./part-index.vue?vue&type=template&id=d96a7e34&scoped=true"
import script from "./part-index.vue?vue&type=script&lang=js"
export * from "./part-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96a7e34",
  null
  
)

export default component.exports